<template>
  <div class="w_100 h_100 homepageBox flexCloumn">
    <dv-decoration-7 style="width:100%;height:1rem;" :color="['#1289ff', '#32c5e9']">
      <div class="pageTitle">招生数据监控中心</div>
    </dv-decoration-7>

    <div class="divideBox flexCenter">
      <div class="flex_1 flexCenter" :class="active==1?'divideItem divideActive':'divideItem'" @click="divideChange(1)"
           style="border-top-left-radius:2px;border-bottom-left-radius:2px;">
        <div :style="active==1?'color:#5cd9e8':''" style="margin-right:6px;">
          <i class="el-icon-notebook-2"></i>
        </div>
        专业登记统计
      </div>
      <div class="flex_1 flexCenter" :class="active==2?'divideItem divideActive':'divideItem'" @click="divideChange(2)"
           style="border-top-right-radius:2px;border-bottom-right-radius:2px;">
        <div :style="active==2?'color:#5cd9e8':''" style="margin-right: 6px;">
          <i class="el-icon-location-information"></i>
        </div>
        区域登记统计
      </div>
    </div>
    <div v-if="active==1" class="dataBox flex_1">
      <div class="list w_100 h_100">
        <van-collapse :value="activeNames" @change="onChangeCollapse">
          <div style="margin-bottom:6px;border-radius:5px;overflow: hidden;" v-for="(item,index) in majorList"
               wx:key="index">
            <van-collapse-item custom-class="listItem" content-class="content" :name="item.title">
              <div slot="title" class="flexBetween">
                <div class="flexStart flex_1">
                  <div class="flexCenter"></div>
                  <div class="flexcenter" style="margin-right:6px;">
                    <i class="el-icon-notebook-2" style="font-size: 16px;color: #5cd9e8;font-weight: 700;"></i>
                  </div>
                  <span class="flex_1 overOneLine">{{ item.title }}</span></div>
                <div class="flexStart" style="white-space: nowrap;">
                  <span style="color:#f00;">{{ item.zs_count }}</span>
                  <span>（人）</span>
                </div>
              </div>
              <div class="lineParentBox" v-for="(items,indexs) in item.children"
                   bindtap="onclick">
                <div :class="actvId===items.id?'actvBg contentItem flexBetween':'contentItem flexBetween'">
                  <span>{{ items.title }}</span>
                  <span style="white-space: nowrap;padding-left: 6px;">{{ items.zs_count }}人</span>
                </div>
                <div class="thinline"></div>
              </div>
            </van-collapse-item>
          </div>
        </van-collapse>
      </div>
    </div>
    <div v-if="active==2" class="dataBox flex_1">
      <div class="list w_100 h_100">
        <van-collapse :value="activeNames_area" @change="onChangeCollapse_area">
          <div style="margin-bottom:6px;border-radius:5px;overflow: hidden;" v-for="(item,index) in areaList"
               wx:key="index">
            <van-collapse-item custom-class="listItem" content-class="content" :name="item.title">
              <div slot="title" class="flexBetween">
                <div class="flexStart flex_1">
                  <div class="flexCenter"></div>
                  <div class="flexcenter" style="margin-right:6px;">
                    <i class="el-icon-location-information" style="font-size: 16px;color: #5cd9e8;font-weight: 700;"></i>
                  </div>
                  <span class="flex_1 overOneLine">{{ item.area_name }}</span></div>
                <div class="flexStart" style="white-space: nowrap;">
                  <span style="color:#f00;">{{ item.zsNum }}</span>
                  <span>（人）</span>
                </div>
              </div>
              <div class="lineParentBox" v-for="(items,indexs) in item.listMajor"
                   bindtap="onclick">
                <div :class="actvId_area===items.id?'actvBg contentItem flexBetween':'contentItem flexBetween'">
                  <span>{{ items.title }}</span>
                  <span style="white-space: nowrap;padding-left: 6px;">{{ items.zs_count }}人</span>
                </div>
                <div class="thinline"></div>
              </div>
            </van-collapse-item>
          </div>
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      tableDataConfig: {},
      pmid: 7,
      active: 1,

      //tab1||:===
      activeNames: [],
      majorList: [],
      actvId: 0,
      //===:||

      //tab2||:===
      activeNames_area: [],
      areaList: [],
      actvId_area: 0
      //===:||
    }
  },
  mounted() {
    this.pmid = this.$route.query.pmid
    this.doIt();
    
  },
  methods: {
    divideChange(num) {
      this.active = Number(num)
    },
    onChangeCollapse(e) {
      this.activeNames = e
    },
    onChangeCollapse_area(e) {
      this.activeNames_area = e
    },
    async doIt() {
      const do1 = await this.getMajorCount();
      const do4 = await this.getAreaCount();
    },
    getMajorCount() {
      return new Promise(resolve => {
        let majorList = []
        this.$http.post("/api/get_student_count_pre_h5",{pmid:this.pmid}).then(res => {
          if (res&&res.data&&res.data.list && res.data.list.length > 0) {
            let treeData = this.listToTree(res.data.list)
            if (treeData && treeData.length > 0) {
              treeData.map(t => {
                t.zs_count = 0
                t.item_plan = 0
                if (t.children && t.children.length > 0) {
                  let zs_count = 0,
                      item_plan = 0
                  t.children.map(major => {
                    major.zs_count = major.zs_count ? major
                        .zs_count : 0
                    major.item_plan = major.item_plan ? major
                        .item_plan : 0
                    zs_count = Number(zs_count) + Number(major
                        .zs_count)
                    item_plan = Number(item_plan) + Number(major
                        .item_plan)
                  })

                  t.zs_count = zs_count
                  t.item_plan = item_plan
                }
              })
            }
            majorList = treeData
          }
          this.majorList = majorList
          resolve(majorList)
        })
      })
    },
    //tab1 utils||:====
    listToTree(oldArr) {
      oldArr.forEach(element => {
        let parentId = element.pid;
        if (parentId !== 0) {
          oldArr.forEach(ele => {
            if (ele.id ==
                parentId) { //当内层循环的ID== 外层循环的parendId时，（说明有children），需要往该内层id里建个children并push对应的数组；
              if (!ele.children) {
                ele.children = [];
              }
              ele.children.push(element);
            }
          });
        }
      });
      //console.log(oldArr) //此时的数组是在原基础上补充了children;
      oldArr = oldArr.filter(ele => ele.pid === 0); //这一步是过滤，按树展开，将多余的数组剔除；
      // console.log(oldArr)
      return oldArr;
    },
    //====:||
    //ScrollTable 各专业各市招生人数
    getAreaCount() {
      this.loading = true
      let params = {
        page: 1,
        pagesize: 100,
        stu_type: 1
        ,pmid:this.pmid
      }
      this.$http.post('/api/sch_area_major_plan_pre_h5', params).then(res => {
        if (res.data.major && res.data.major.length > 0) {
          let arr = []
          res.data.major.map(a => {
            // console.log(a)

            a.children && a.children.map(b => {
              // console.log(b)
              b.area && b.area.length>0&&b.area.map(d=>{
                // console.log(d)
                d.children &&d.children.length>0&& d.children.map(c => {
                  // console.log(c)
                  let arr1 = []
                  c.newMajor = []
                  arr1.push({
                    parent: c.area_code,
                    title: b.title,
                    zs_count: c.zs_count,
                    item_plan: c.plan.num
                  })
                  c.newMajor = arr1
                  arr.push(c)
                })
              })
            })
          })
          let groupArr = this.groupBy(arr, function (item) {
            return [item.area_name]
          })
          let treeArr = this.toTree(groupArr)
          // console.log(groupArr, treeArr)
          let zsNum = 0, planNum = 0
          this.areaList = treeArr
        }


      })
    },
    //tab2 utils ||:===
    groupBy(array, f) {
      let groups = {};
      array.forEach(function (o) {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    },
    toTree(array) {
      let result = []
      let result1 = []
      array.map(a => {
        let arr = []
        a && a.map(b => {
          b.listMajor = []
          arr = arr.concat(b.newMajor)
          b.listMajor = arr
        })
        result.push(a)
      })
      result.map(r => {
        let zsNum = 0, planNum = 0
        if (r && r.length > 0) {
          let len = r.length
          r[len - 1].listMajor.map(a => {
            zsNum = zsNum + a.zs_count
            planNum = planNum + a.item_plan

          })
          // console.log(zsNum, planNum)
          r[len - 1].zsNum = zsNum
          r[len - 1].planNum = planNum
          result1.push(r[len - 1])
        }
      })
      // console.log(result1)
      return result1;
    },
    unique(data) {
      let Array = [] //存放去重过后的数据
      let obj = {}
      //去除data,里面index相同的对象
      for (var i = 0; i < data.length; i++) {
        if (!obj[data[i].area_name]) {
          Array.push(data[i])
          obj[data[i].area_name] = true
        }
      }
      return Array
    },
    //===:||


    //各项费用
    valueFormatter(value) {
      const reverseNumber = (value + '').split('').reverse()
      let valueStr = ''

      while (reverseNumber.length) {
        const seg = reverseNumber.splice(0, 3).join('')
        valueStr += seg
        if (seg.length === 3) valueStr += ','
      }

      return valueStr.split('').reverse().join('')
    },

  },
}
</script>
<style lang="less" type="text/less">
.chartBox .bg-color-black {
  height: 100%;
}
.homepageBox {
  .list {

    .listItem .van-cell {
      padding: 15px 20px!important;
    }

  }
}
</style>
<style scope lang="less" type="text/less">
.w_100 {
  width: 100%;
}

.h_100 {
  height: 100%
}

div {
  box-sizing: border-box
}

.homepageBox {
  padding: 20px;
  box-sizing: border-box;
  background-color: #EEF2F5;
  //隐藏滚动条
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
.pageTitle{
  font-size: 18px;font-weight: 600;
  padding: 0 10px;  background-image:-webkit-linear-gradient(bottom,#37A2DA,#32c5e9, #67E0E3);

  -webkit-background-clip:text;

  -webkit-text-fill-color:transparent;
}
  .divideBox {
    width: 100%;
    margin-top: 20px;

    .divideItem {
      padding: 4px 18px;
      color: #CDCBCE;
      background-color: #fff;
      border: 1px solid #F3F3F3;
    }

    .divideActive {
      color: #fff;
      background-color: #1283FF;
      border: none;
      border-radius: 2px;
    }
  }

  .dataBox {
    width: 100%;
    overflow-y: scroll;
    margin-top: 10px;

    .list {

      .listItem .van-cell {
        padding: 15px 20px;
      }

      span {
        font-size: 16px;
        font-weight: 700;
        color: #000;
      }

      .content {
        border-top: 1px solid #E9E9EF;
        padding: 0;
      }

      .contentItem {
        /*border-top: 1px solid #E9E9EF;*/
        padding: 20px 36px;
        width: 100%;
      }

      .contentItem:first-of-type {
        border-top: 0;
      }

      .contentItem span {
        color: #474747;
        font-size: 14px;
        font-weight: normal;
      }

      .actvBg {
        background-color: #ECF4FE;
      }

      .thinline {
        width: calc(100% - 40px);
        margin: 0 auto;
        background-color: #E9E9EF;
        position: relative;
        height: 1px;
      }

      .thinline:before {
        content: '';
        left: 0;
        position: absolute;
        width: 200%;
        height: 200%;
        border-top: 1px solid #ddd;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
      }

      .lineParentBox:last-of-type .thinline {
        display: none;
      }
    }
  }
}

@import "../../../assets/home";
.homeContainer {
  div {
    box-sizing: border-box;
  }

  .pdng10 {
    padding: 10px;
  }

  .pdng_rem_dot2 {
    padding: 0.2rem;
  }

  .border {
    border: 0.5px solid #1a5cd7;
    border-radius: 16px;
  }

  .topBar {
    width: 100%;
    height: 9.2%;
    box-sizing: border-box;
  }
}

.chartBox {
  width: 100%;
  height: 100%;

  //隐藏滚动条
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  .anim {
    transition: all 5s;
    margin-top: -65.5px;
  }
}

.prograssBarBox {
  .boxItem {
    height: 65.5px;

    //padding: 15px 10px;
    .itemContainer {
      width: 100%;
    }

    .rank {
      width: 40px;
      color: #1370fb;
    }
  }
}
</style>
